import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SuperAdminService } from 'src/app/super-admin.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-view-tracker-invoice',
  templateUrl: './view-tracker-invoice.component.html',
  styleUrls: ['./view-tracker-invoice.component.css']
})
export class ViewTrackerInvoiceComponent implements OnInit {

  checkInvoiceType: any;
  invtot: any = 0;
  tooltaxPaidtot: any = 0;
  extrahour: any = 0;
  kmtot: any = 0;

  users: any[] = [];
  paramId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private superAdminService: SuperAdminService
  ) {
    this.route.params.subscribe(param => {
      this.paramId = param.id;
      this.getTrackerInvoice(this.paramId);
    });
  }

  ngOnInit(): void {}

  // 🔹 TRACKER INVOICE FETCH (same structure as LR)
  getTrackerInvoice(id: string) {
    this.superAdminService.getParticularInvoice(id).subscribe(
      (res: any) => {
        if (res.status) {
          const rawdata = res.data;

          this.checkInvoiceType =
            rawdata[0]?.invoice[0]?.invoiceTypeName?.[0] || 'Type1';

          this.users = rawdata[0]?.invoice || [];

          // RESET TOTALS
          this.invtot = 0;
          this.kmtot = 0;
          this.extrahour = 0;
          this.tooltaxPaidtot = 0;

          // CALCULATE TOTALS (SAME AS LR)
          this.users.forEach((user: any) => {
            this.invtot += (user.vehicleRate || []).reduce(
              (a: number, b: any) => a + Number(b || 0),
              0
            );
            this.kmtot += (user.up_down_km || []).reduce(
              (a: number, b: any) => a + Number(b || 0),
              0
            );
            this.extrahour += (user.extrahour || []).reduce(
              (a: number, b: any) => a + Number(b || 0),
              0
            );
            this.tooltaxPaidtot += (user.tooltaxPaid || []).reduce(
              (a: number, b: any) => a + Number(b || 0),
              0
            );
          });

        } else {
          this.toastr.error(res.message);
        }
      },
      err => console.error(err)
    );
  }

  // 🔹 SEND EMAIL (PDF) – SAME AS LR
  // sendInvoice(divName: string) {
  //   const data = document.getElementById(divName);
  //   if (!data) return;

  //   html2canvas(data).then(canvas => {
  //     const imgWidth = 208;
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
  //     const contentDataURL = canvas.toDataURL('image/png', 0.3);

  //     const pdf = new jsPDF('p', 'mm', 'a4');
  //     pdf.addImage(
  //       contentDataURL,
  //       'PNG',
  //       1,
  //       1,
  //       imgWidth,
  //       imgHeight,
  //       undefined,
  //       'FAST'
  //     );

  //     let binary = pdf.output();
  //     binary = binary ? btoa(binary) : '';

  //     this.superAdminService.sendTrackerInvoice(this.paramId, binary).subscribe(
  //       (res: any) => {
  //         res.status
  //           ? this.toastr.success(res.message)
  //           : this.toastr.error(res.message);
  //       }
  //     );
  //   });
  // }

  backTo() {
    window.history.back();
  }
}
